import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import Index from './pages/Index'
import NotFound from './pages/NotFound'
import Layout from './components/Layout'
import { AuthProvider } from '@/hooks/use-auth'
import { AuthGuard } from '@/components/auth/AuthGuard'
import AdminLayout from '@/components/AdminLayout'
import Login from '@/pages/Login'
import JobsPage from '@/pages/admin/Jobs'
import EducatorsPage from '@/pages/admin/Educators'
import MatchesPage from '@/pages/admin/Matches'
import PostJob from '@/pages/PostJob'
import EducatorRegistration from '@/pages/EducatorRegistration'
import { GoogleAdsTag } from '@/components/GoogleAdsTag'

const App = () => (
  <AuthProvider>
    <GoogleAdsTag />
    <BrowserRouter
      future={{ v7_startTransition: false, v7_relativeSplatPath: false }}
    >
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<Index />} />
            <Route path="/anunciar-vaga" element={<PostJob />} />
            <Route
              path="/cadastro-educador"
              element={<EducatorRegistration />}
            />
          </Route>

          <Route path="/login" element={<Login />} />

          {/* Protected Admin Routes */}
          <Route element={<AuthGuard />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/jobs" replace />} />
              <Route path="jobs" element={<JobsPage />} />
              <Route path="educators" element={<EducatorsPage />} />
              <Route path="matches" element={<MatchesPage />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </TooltipProvider>
    </BrowserRouter>
  </AuthProvider>
)

export default App
